export default __webpack_public_path__ + "static/media/dashbaord_cancel_icon.2f8247e2.svg";